import { render, staticRenderFns } from "./GrantOrg.vue?vue&type=template&id=120b72b6&scoped=true"
import script from "./GrantOrg.vue?vue&type=script&lang=js"
export * from "./GrantOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b72b6",
  null
  
)

export default component.exports